// logger.js

let production = false;

export const mylog = (message, ...args) => {
    if (!production) {
        console.log(message, args)
    }
}
